import { render, staticRenderFns } from "./TypePropertyTable.vue?vue&type=template&id=080eca6c&scoped=true"
import script from "./TypePropertyTable.vue?vue&type=script&lang=js"
export * from "./TypePropertyTable.vue?vue&type=script&lang=js"
import style0 from "./TypePropertyTable.vue?vue&type=style&index=0&id=080eca6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080eca6c",
  null
  
)

export default component.exports